// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Note_buttons__2EE8Y"};